module.exports = __webpack_public_path__ + "img/no_zone.5a6bc231.svg";